import React from "react";

function TitleDescription({
  title = "Lets talk about your project requirements",
  description = "",
  description2="",
  image,
  isHidden = true,
}) {
  return (
    <div
      data-aos="fade-right"
      className={`my-3 mx-5 lg:text-left text-center lg:block ${
        isHidden ? "hidden" : ""
      } `}
    >
      <h1 className="lg:text-4xl text-3xl">{title}</h1>
      {title !== "" && (
        <div className="flex lg:justify-start justify-center">
          <p className="border-b-2 border-subMain lg:w-40 w-40  my-5"></p>
        </div>
      )}
      <p className={"lg:text-base text-sm"}>{description}</p>
      <p className={"lg:text-base text-sm"}>{description2}</p>
      {image && (
        <div className="flex justify-center">
          <img
            loading="lazy"
            src={
              image
                ? image
                : "https://ik.imagekit.io/0hhctrxcv/thanweconsultants/illustration_contact_us.jpeg?ik-sdk-version=javascript-1.4.3&updatedAt=1677827219187"
            }
            alt="contact-us"
            className="object-contain w-full h-[500px]"
          />
        </div>
      )}
    </div>
  );
}

export default TitleDescription;
